<script setup lang="ts">
defineProps({
  currentStep: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['step-change']);
</script>

<template>
  <div class="form-progress-bar" :class="{completed: currentStep == 3}">
    <ul>
      <li :class="{selected: currentStep == 0, completed: currentStep > 0}" @click="emit('step-change', 0)">Introduction</li>
      <li :class="{selected: currentStep == 1, completed: currentStep > 1}" @click="emit('step-change', 1)">Event Details</li>
      <li :class="{selected: currentStep == 2, completed: currentStep > 2}" @click="emit('step-change', 2)">My Info</li>
      <li :class="{selected: currentStep == 3, completed: currentStep > 3}" @click="emit('step-change', 3)">Summary</li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
@use '@/assets/scss/queries';
.form-progress-bar {
  background: linear-gradient(90deg, #71adb5 0%, #71adb5 50%, var(--ever-color-darker) 50%);
  background-color: #4d757a;
  width: 100%;

  &.completed {
    background: var(--ever-color);
  }

  ul {
    color: white;
    display: flex;

    font-size: 2rem;
    font-weight: 700;
    justify-content: space-between;
    line-height: 1;
    list-style-type: none;
    margin: 0 auto;
    max-width: 1366px;
    padding: 0;
    width: 100%;

    li {
      align-items: center;
      background-color: var(--ever-color-darker);
      cursor: pointer;
      display: flex;
      flex: 1;
      font-size: 2rem;
      height: 50px;
      justify-content: center;
      position: relative;

      @include queries.for-size(ipadpro-portrait-down) {
        font-size: 1.5rem;
      }

      &.selected {
        background: #71adb5;
      }

      &:not(:last-child) {
        &.selected {
          &:before {
            background-color: var(--ever-color-darker);
            border-bottom: 25px solid transparent;
            border-left: 25px solid #71adb5;
            border-top: 25px solid transparent;
            content: '';
            position: absolute;
            right: 0;
            top: 0;
          }
        }
      }

      &.completed {
        background: #71adb5;
      }
    }
  }
}
</style>
